import React from 'react';
import PropTypes from 'prop-types';
import { IMAGE_CONSTANTS } from '../../constants/ImageConstans';
import './RapFireQuestionPoints.css';

/** Map API/MQTT gameState values to icon states */
export const mapGameStateToPointStates = (gameState = []) =>
  gameState.map((state) => {
    if (state === 'correct') return 'correct';
    if (state === 'wrong' || state === 'timeout') return 'wrong';
    return 'pending';
  });

/** Figma 18423:5206 — 5 question progress dots (20×20, 5px gap) */
const ICON_MAP = {
  correct: IMAGE_CONSTANTS.V2_RAPFIRE_QA_CHECK,
  wrong: IMAGE_CONSTANTS.V2_RAPFIRE_QA_CROSS,
  pending: IMAGE_CONSTANTS.V2_RAPFIRE_QA_PENDING,
};

const RapFireQuestionPoints = ({ states = [] }) => {
  if (!states?.length) return null;

  return (
    <div
      className="rap-fire-qa-points"
      aria-label="Question progress"
      data-node-id="18423:5206"
    >
      {states.map((state, index) => {
        const icon = ICON_MAP[state] || ICON_MAP.pending;
        const label =
          state === 'correct'
            ? `Question ${index + 1}: correct`
            : state === 'wrong'
              ? `Question ${index + 1}: incorrect`
              : `Question ${index + 1}: pending`;
        return (
          <img
            key={`qa-point-${index}`}
            className="rap-fire-qa-points__icon"
            src={icon}
            alt=""
            aria-label={label}
            width={20}
            height={20}
          />
        );
      })}
    </div>
  );
};

RapFireQuestionPoints.propTypes = {
  states: PropTypes.arrayOf(
    PropTypes.oneOf(['correct', 'wrong', 'pending'])
  ),
};

export default RapFireQuestionPoints;
